/* global axios */
import ApiClient from './ApiClient';

class PipelinesApi extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  show(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}`);
  }

  update(pipelineId, data) {
    return axios.patch(`${this.url}/${pipelineId}`, data);
  }

  delete(pipelineId) {
    return axios.delete(`${this.url}/${pipelineId}`);
  }

  listStages(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/stages`);
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/stages`, data);
  }

  updateStage(stageId, data) {
    return axios.patch(`${this.baseUrl()}/stages/${stageId}`, data);
  }

  deleteStage(stageId) {
    return axios.delete(`${this.baseUrl()}/stages/${stageId}`);
  }

  reorderStages(pipelineId, stageIds) {
    return axios.patch(`${this.url}/${pipelineId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }

  getItems(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/items`, { params });
  }

  getItem(pipelineId, itemId) {
    return axios.get(`${this.url}/${pipelineId}/items/${itemId}`);
  }

  addItem(pipelineId, payload) {
    return axios.post(`${this.url}/${pipelineId}/items`, payload);
  }

  updateItem(pipelineId, id, data) {
    return axios.patch(`${this.url}/${pipelineId}/items/${id}`, data);
  }

  moveItem(pipelineId, id, payload) {
    return axios.patch(`${this.url}/${pipelineId}/items/${id}/move`, payload);
  }

  removeItem(pipelineId, id) {
    return axios.delete(`${this.url}/${pipelineId}/items/${id}`);
  }

  eligibleConversations(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/items/eligible_conversations`, {
      params,
    });
  }

  restartJourney(pipelineId, itemId) {
    return axios.patch(`${this.url}/${pipelineId}/items/${itemId}/restart_journey`);
  }

  getItemMoves(pipelineId, itemId) {
    return axios.get(`${this.url}/${pipelineId}/items/${itemId}/moves`);
  }

  clone(pipelineId) {
    return axios.post(`${this.url}/${pipelineId}/clone`);
  }

  getAgents(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/agents`);
  }

  setAgents(pipelineId, userIds) {
    return axios.put(`${this.url}/${pipelineId}/agents`, { user_ids: userIds });
  }
}

export default new PipelinesApi();
